<script lang="ts">
  import {
    flixMediaDataAvailabilityChecked,
    flixMediaDataAvailable,
    pdpMoreInfoActiveTab,
    productDetailMainData,
    testFreakData,
  } from '../store/pdp_store';
  import MpClassificationFeatures from './MPComponents/MPClassificationFeatures.svelte';
  import ProductRating from './ProductRating/ProductRating.svelte';
  import ProductReview from './ProductReview.svelte';
  import ProductGroupedFeatures from './ProductStory/ProductGroupedFeatures.svelte';
  import Text from './../../common/components/Text.svelte';
  import { replaceNewlinesToBRs } from '../../../common/util';

  export let data: any;
  export let isDataLoaded = false;
  export let FlixStyle = 'flex';
  export let distributorId: string | undefined = undefined;
  export let flixmediaLanguage: string | undefined = undefined;
  export let modelNumber: string | undefined = undefined;
  export let flixInpage: string | undefined = undefined;
  export let flixButtonImage: string | undefined = undefined;
  export let fallbackLanguage: string | undefined = undefined;
  export let flixPrice: string | undefined = undefined;
  export let enableRichMedia = true;
  export let onOpenWriteReview = () => {};
  export let preorder: boolean = false;
</script>

<div
  class:c_discovercontent={preorder}
  class="{!isDataLoaded ? 'p_0 ' : ''}{$pdpMoreInfoActiveTab == 'Discover'
    ? 'popup-conent discover-section show'
    : 'popup-conent discover-section hide'}"
>
  {#if data?.highlights !== null}
    {@html data?.highlights}
  {:else if enableRichMedia && data?.highlightsProvider === 'TTL_24'}
    <div id="ttl_24-inpage" class="ttl-24-section"></div>
  {:else if enableRichMedia && $flixMediaDataAvailable && $flixMediaDataAvailabilityChecked}
    <div class="flix_loaderContainer" style={`display:${FlixStyle}`}>
      <div class="flix_loader"></div>
    </div>
    <div id="flix-inpage"></div>
    <script
      type="text/javascript"
      src="//media.flixfacts.com/js/loader.js"
      data-flix-distributor={distributorId}
      data-flix-language={flixmediaLanguage}
      data-flix-brand={data?.brandName}
      data-flix-mpn={modelNumber}
      data-flix-ean=""
      data-flix-sku=""
      data-flix-inpage={flixInpage}
      data-flix-button-image={flixButtonImage}
      data-flix-fallback-language={fallbackLanguage}
      data-flix-price={flixPrice}
      async
    >
    </script>
  {:else if $productDetailMainData.isMarketPlaceProduct && data?.description != null}
    <div class="product-desc">
      <div class="heading">
        <Text key="extra.marketplace.product.description" />
      </div>
      <span class="description">
        {@html replaceNewlinesToBRs(data?.description)}
      </span>
    </div>
  {/if}
</div>
{#if !preorder}
  <div class={$pdpMoreInfoActiveTab == 'GeekyInfo' ? 'popup-conent show' : 'popup-conent hide'}>
    {#if $productDetailMainData.isMarketPlaceProduct}
      <MpClassificationFeatures {data} />
    {:else}
      <ProductGroupedFeatures {data} />
    {/if}
  </div>
  <div class={$pdpMoreInfoActiveTab == 'Setup' ? 'popup-conent show' : ' popup-conent hide'}>
    <div class="title-text">Setup content here</div>
  </div>
  <div class={$pdpMoreInfoActiveTab == 'Blog' ? 'popup-conent show' : 'popup-conent hide'}>
    <div class="title-text">Blog content here</div>
  </div>
  <div class={$pdpMoreInfoActiveTab == 'Reviews' ? 'popup-conent show' : 'popup-conent hide'}>
    <div class="title-text">
      <ProductRating testFreakData={$testFreakData} />
      <ProductReview testFreakData={$testFreakData} isGeekInfolink={true} on:openWriteReview={onOpenWriteReview} />
    </div>
  </div>
  <div class={$pdpMoreInfoActiveTab == 'Q&A' ? 'popup-conent show' : 'popup-conent hide'}>
    <div class="title-text">Q&A content here</div>
  </div>
  <div class={$pdpMoreInfoActiveTab == 'Compare' ? 'popup-conent show' : 'popup-conent hide'}>
    <div class="title-text">Compare content here</div>
  </div>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .popup-conent {
    &.hide {
      display: none;
    }
    &.discover-section {
      text-align: center;
      padding: 0 15px;
      margin-top: 40px;
      display: flex;
      justify-content: center;
      &.hide {
        display: none;
      }
      &.c_discovercontent {
        margin-top: 10px;
      }
      .ttl-24-section {
        padding: 1rem;
        @include desktop-min-width {
          padding: 0;
        }
      }
      @include desktop-min-width {
        // padding: 60px;
      }
    }
  }
  .product-desc {
    text-align: left;
    .heading {
      font-size: 18px;
      line-height: 16px;
      margin-bottom: 14px;
      font-weight: 700;
    }
    .description {
      margin: 0;
      font-size: 18px;
      line-height: 24px;
    }
  }
</style>
